import { impactTimeline } from "@/mocks/gossip";
import { SectionHead } from "./ui";

const statusStyle: Record<string, { badge: string; dot: string; icon: string }> = {
  实锤: { badge: "bg-primary-500 text-background-50", dot: "bg-primary-500", icon: "ri-check-double-line" },
  反转: { badge: "bg-accent-500 text-background-50", dot: "bg-accent-500", icon: "ri-refresh-line" },
  辟谣: { badge: "bg-secondary-600 text-background-50", dot: "bg-secondary-600", icon: "ri-shield-check-line" },
  冷场: { badge: "bg-foreground-700 text-background-50", dot: "bg-foreground-700", icon: "ri-snowy-line" },
};

export default function ImpactSection() {
  return (
    <section id="impact" className="bg-background-100/60">
      <div className="mx-auto max-w-[1200px] px-4 py-10 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHead
              eyebrow="Evidence · 冷暖翻车实锤"
              title="实锤档案：每一颗瓜都标好阶段"
              sub="热搜来得快，忘得更快。我们用时间线把“冷暖、翻车与实锤”一件件归档，让你错过开头也能从结尾补课。"
            />
            <div className="rounded-2xl bg-primary-600 p-6 text-background-50">
              <div className="flex items-center gap-2 text-background-50/85">
                <i className="ri-error-warning-fill text-lg" />
                <span className="text-xs font-medium tracking-wide">吃瓜提醒</span>
              </div>
              <p className="mt-3 text-sm leading-7 text-background-50/90">
                网络截图与片段极易断章取义。「刚刚爆料」对未经当事人证实的消息一律标注“待实锤”，只陈述已公开信息，不替任何一方“盖章定罪”。
              </p>
              <div className="mt-5 flex flex-wrap gap-2 text-xs">
                <span className="rounded-full bg-background-50/15 px-3 py-1.5">理性围观</span>
                <span className="rounded-full bg-background-50/15 px-3 py-1.5">以官方为准</span>
                <span className="rounded-full bg-background-50/15 px-3 py-1.5">拒绝网暴</span>
              </div>
            </div>
          </div>

          <ol className="relative space-y-6 lg:col-span-8">
            <span className="absolute left-[13px] top-2 h-[calc(100%-16px)] w-px bg-background-300 lg:left-[15px]" />
            {impactTimeline.map((ev) => {
              const s = statusStyle[ev.status];
              return (
                <li key={ev.day} className="relative flex gap-4 pl-10 lg:gap-6 lg:pl-12">
                  <span className={`absolute left-0 top-6 grid h-7 w-7 place-items-center rounded-full text-background-50 ${s.dot}`}>
                    <i className={`${s.icon} text-xs`} />
                  </span>
                  <div className="flex-1 rounded-2xl border border-background-200 bg-background-50 p-5 transition hover:border-background-300 md:p-6">
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="font-heading text-sm font-black text-primary-600">{ev.day}</span>
                      <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-bold ${s.badge}`}>
                        {ev.status}
                      </span>
                    </div>
                    <h3 className="font-heading mt-2.5 text-base font-bold text-foreground-950 md:text-lg">{ev.title}</h3>
                    <p className="mt-2 text-sm leading-7 text-foreground-600">{ev.desc}</p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}